module.exports = __webpack_public_path__ + "static/assets/25764ef2638fb7a127295be59e476d9e.svg";